import { render, staticRenderFns } from "./DataTableV2.vue?vue&type=template&id=f8fc763e&scoped=true"
import script from "./DataTableV2.vue?vue&type=script&lang=js"
export * from "./DataTableV2.vue?vue&type=script&lang=js"
import style0 from "./DataTableV2.vue?vue&type=style&index=0&id=f8fc763e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fc763e",
  null
  
)

export default component.exports